export default "__VITE_ASSET__B6XGhHq9__"